import '../scss/index.scss';
import { SitePad } from './site-pad';

// import { Tooltip, Toast, Popover } from 'bootstrap';
// import Modal from 'bootstrap/js/dist/modal';

var sitepad = new SitePad();
sitepad.init();
